import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import serverData from '../../api/ServerData'
import { useNavigate } from 'react-router-dom'
import { colorWithOpacity, isEmpty, showToast } from '../../utils/AppHelper'
import { CircularProgress, Grid, useTheme } from '@mui/material'
import AppIcon from '../../commonComponents/AppIcon'
import { TextRegular, TextSemiBold } from '../../commonComponents/TextStyling'

export default function RejectCandidate () {
  const navigate = useNavigate()
  const location = useLocation()
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const [item, setItem] = useState({})

  var theme = useTheme()

  useEffect(function () {
    const query = new URLSearchParams(location.search) // eslint-disable-next-line
    const token = query.get('token')
    if (isEmpty(token)) {
      setError(true)
    } else {
      setLoading(true)
      serverData.rejectCandidateApplication(
        { token },
        data => {
          if (data.status) {
            setItem(data.response)
          } else {
            navigate('/') // eslint-disable-next-line
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }, [])

  return error ? (
    <h2 style={{ alignSelf: 'center' }}> Invalid Request</h2>
  ) : (
    <Grid
      container
      style={{
        background: theme.palette.background.light,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      {/* header */}
      <Grid item xs={12} style={{ height: '10vh' }}>
        <Grid container>
          <Grid
            item
            xs={3}
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '10px',
              marginBottom: '10px'
            }}
          >
            <AppIcon style={{ width: '6rem', height: 44 }} />
          </Grid>
        </Grid>
      </Grid>

      {loading ? (
        <Grid
          container
          spacing={2}
          direction={'column'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
            width: '100%'
          }}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
          <Grid item>
            <TextRegular>Searching...</TextRegular>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          style={{
            background: theme.palette.background.light,
            display: 'flex',
            justifyContent: 'center',
            height: '90vh',
            marginTop: '32px'
          }}
        >
          <Grid
            item
            xs={8}
            style={{
              border: `1px solid ${theme.palette.text.success}`,
              margin: '16px',
              display: 'flex',
              padding: '16px',
              borderRadius: '4px',
              backgroundColor: `${theme.palette.background.successBack}`,
              height: 'fit-content'
            }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', alignItems: 'flex-start' }}
              >
                <TextSemiBold
                  style={{
                    color: `${theme.palette.text.success}`,
                    fontSize: '18px'
                  }}
                >
                  Hello {item?.candidateFirstName} {item?.candidateLastName}!
                </TextSemiBold>
              </Grid>
              <Grid item xs={12}>
                <TextRegular style={{ color: `${theme.palette.text.success}` }}>
                  We have notified {item?.recruiterFirstName} that you are not
                  interested in the opportunity: {item?.jobTitle} To learn more
                  about our Talent CrowdSourcing Platform please visit our
                  website, Thank you.
                </TextRegular>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}
